import React, { useEffect, useState } from "react";
import { Service } from "utils/services";
import NewFeedImagesSlideSponsor from "./new-feed-components/NewFeedImagesSlideSponsor";
import NewFeedVideoSponsor from "./NewFeedVideoSponsor";
import { RequestApi, RouteApi } from "utils";
import { AppRecordStatus } from "models/appRecord";
import ImageUrlProfile from "../image-url/ImageUrlProfile";

import { ShimmerNewFeedRightJobs, ShimmerNewFeedRightSideSpnsored } from "components/app/shrimmer/Shrimmer";

import appStore from "store/appStore";
import { useLocation } from "react-router-dom";

const fetchHomeMarketPlaceSponsored = async (): Promise<any[]> => {
  // let url = RouteApi.getHomeMarketPlaceSponsored;
  let url = Service.userAuth ? RouteApi.getHomeMarketPlaceSponsored : RouteApi.getHomeMarketplaceSponsoredGuest;
  url += `token=${Service?.token}`;
  const responses = await RequestApi(url);
  if (responses.status === "success") {
    return responses.posts;
  } else {
  }

  return [];
};

const fetchHomeMarketPlaceJob = async (): Promise<any[]> => {
  // let url = RouteApi.getHomeMarketPlaceJob;
  let url = Service.userAuth ? RouteApi.getHomeMarketPlaceJob : RouteApi.getHomeMarketplaceJobGuest;
  url += `token=${Service?.token}`;

  const responses = await RequestApi(url);
  if (responses.status === "success") {
    return responses.posts;
  } else {
  }

  return [];
};

const fetchHomeMarketplaceLookingJob = async (): Promise<any[]> => {
  let url = Service.userAuth ? RouteApi.getHomeMarketplaceLookingJob : RouteApi.getHomeMarketplaceLookingJobGuest;
  url += `token=${Service?.token}`;
  const responses = await RequestApi(url);
  if (responses.status === "success") {
    return responses.posts;
  } else {
  }
  return [];
};

const NewFeedRightSidebar: React.FC = () => {
  const location = useLocation();
  const { onOpenDialogPostModal } = appStore();

  const [hovered, setHovered] = useState(false);

  const [sponsoredStatus, setSponsoredStatus] = useState<AppRecordStatus>(AppRecordStatus.loading);

  const [jobStatus, setJobStatus] = useState<AppRecordStatus>(AppRecordStatus.loading);
  const [lookingJobtatus, setLookingJobStatus] = useState<AppRecordStatus>(AppRecordStatus.loading);

  const [sponsored, setSponsored] = useState<any>(null);
  const [banner1, setBanner1] = useState<any>(null);
  const [banner2, setBanner2] = useState<any>(null);

  const [jobs, setJobs] = useState<any[]>([]);
  const [lookingJobs, setLookingJobs] = useState<any[]>([]);

  const onGoToPost = (postId: string) => {
    onOpenDialogPostModal(postId, location.pathname);
  };

  useEffect(() => {
    const loadInitialPosts = async () => {
      const posts = await fetchHomeMarketPlaceSponsored();
      if (posts.length > 0) {
        setSponsored({ ...posts[0] });
        setBanner1({ ...posts[1] });
        setBanner2({ ...posts[2] });
      }
      setSponsoredStatus(AppRecordStatus.loaded);

      const tmpJobs = await fetchHomeMarketPlaceJob();
      setJobs(tmpJobs);
      setJobStatus(AppRecordStatus.loaded);

      const tmpHiring = await fetchHomeMarketplaceLookingJob();
      setLookingJobs(tmpHiring);
      setLookingJobStatus(AppRecordStatus.loaded);
    };

    loadInitialPosts();
  }, []);

  return (
    <div
      className={`p-4 h-full space-y-6  overflow-y-auto ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Sponsored Section */}
      <div>
        <h4 className="text-sm font-semibold mb-2">Sponsored</h4>
        <div className="space-y-4">
          {sponsoredStatus === AppRecordStatus.loading ? (
            <ShimmerNewFeedRightSideSpnsored />
          ) : (
            <>
              <NewFeedVideoSponsor sponsored={sponsored} onOpenPostModal={onGoToPost} />

              <NewFeedImagesSlideSponsor banner={banner1} onOpenPostModal={onGoToPost} />

              <NewFeedImagesSlideSponsor banner={banner2} onOpenPostModal={onGoToPost} />
            </>
          )}
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-300"></div>

      {/* Jobs Section */}
      <div>
        <h4 className="text-sm font-semibold  mb-2">We are hiring</h4>
        <div className="space-y-4">
          {jobStatus === AppRecordStatus.loading ? (
            <ShimmerNewFeedRightJobs />
          ) : jobs.length > 0 ? (
            jobs.map((job, index) => (
              <div key={index} className="flex items-center space-x-3">
                <ImageUrlProfile user={job.user} className="w-16 h-16 rounded-md object-cover" isLinkProfile={true} />

                <div>
                  <h5 className="text-sm font-medium hover:underline cursor-pointer" onClick={() => onGoToPost(job.post_id)}>
                    {job.professional}
                  </h5>

                  <a href={job.user.website} rel="noopener noreferrer" target="_blank" className="text-xs text-muted-foreground hover:underline break-all">
                    {Service.replaceText(job.user.website, ["https://", "http://", "www."], "")}
                  </a>
                </div>
              </div>
            ))
          ) : (
            <p className="text-xs text-muted-foreground">You have no job suggestions.</p>
          )}
        </div>
      </div>

      {/* Hiring */}
      <div>
        <h4 className="text-sm font-semibold  mb-2">I am looking a job</h4>
        <div className="space-y-4">
          {lookingJobtatus === AppRecordStatus.loading ? (
            <ShimmerNewFeedRightJobs />
          ) : lookingJobs.length > 0 ? (
            lookingJobs.map((hiring, index) => (
              <div key={index} className="flex items-center space-x-3">
                <ImageUrlProfile user={hiring.user} className="w-16 h-16 rounded-md object-cover" isLinkProfile={true} />

                <div>
                  <h5 className="text-sm font-medium hover:underline cursor-pointer" onClick={() => onGoToPost(hiring.post_id)}>
                    {hiring.professional}
                  </h5>

                  <span>
                    <a href={hiring.user.website} rel="noopener noreferrer" target="_blank" className="text-xs text-muted-foreground hover:underline break-all">
                      {Service.replaceText(hiring.user.website, ["https://", "http://", "www."], "")}
                    </a>
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-xs text-muted-foreground">Currently, there are no individuals actively seeking employment.</p>
          )}
        </div>
      </div>

      <div className="h-2"></div>
      {/* Divider */}
      {/* <div className="border-t border-gray-300"></div> */}
    </div>
  );
};

export default NewFeedRightSidebar;

